import { Context, Middleware } from '@nuxt/types'
import { IRegionLocation } from '~/model/RegionLocation'

const geoLocationMiddleware: Middleware = async ({ $services, $tstore }: Context) => {
  try {
    if ($tstore.regionLocation.RegionLocationList.length === 0) {
      const regions = await $services.geolocation.getRegions<IRegionLocation[]>()
      if (regions) {
        $tstore.regionLocation.setRegionLocationList(regions)
      }
    }

    const region = $services.geolocation.getCookieRegion()
    if (region) {
      $tstore.regionLocation.setRegionLocationItem(region)
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('GeoLocation middleware error:', error)
  }
}

export default geoLocationMiddleware
